import CultureCodeEnum from '../../../../../models/culture-code-enum';
import client from '../../../client';

const favouritesLineAdd = async (
  basketId: string,
  sku: string,
  variantSku: string
): Promise<void> => {
  const { data } = await client.put<void>(
    '/favourites/line/add',
    {
      quantity: 1,
      sku,
      variantSku,
    },
    { params: { basketId, cultureCode: CultureCodeEnum.EnGb } }
  );

  return data;
};

export default favouritesLineAdd;
